import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';

@Injectable({
  providedIn: 'root',
})
export class LookupMasterService {
  private http = inject(HttpClient);
  private apiUrl: string;

  constructor(@Inject(EnvConfig) private config: Environment) {
    this.apiUrl = this.config.apiUrl;
  }

  getLookupTypes(body: {
    pageIndex?: number;
    pageSize?: number;
    searchTerm?: string;
  }) {
    const link = `${this.apiUrl}${ApiUrls.lookupTypeGetList}`;
    return this.http.post<any>(link, body);
  }

  getLookupTypeById(id: number) {
    const link = `${this.apiUrl}${ApiUrls.lookupTypeGetById}/${id}`;
    return this.http.get<any>(link);
  }

  createLookupType(body: {
    nameEn?: string;
    nameAr?: string;
    descriptionEn?: string;
    descriptionAr?: string;
    NameEn?: string;
    NameAr?: string;
    DescriptionEn?: string;
    DescriptionAr?: string;
  }) {
    const link = `${this.apiUrl}${ApiUrls.lookupTypeCreate}`;
    return this.http.post<any>(link, body);
  }

  updateLookupType(body: {
    id?: number;
    Id?: number;
    nameEn?: string;
    nameAr?: string;
    descriptionEn?: string;
    descriptionAr?: string;
    NameEn?: string;
    NameAr?: string;
    DescriptionEn?: string;
    DescriptionAr?: string;
  }) {
    const link = `${this.apiUrl}${ApiUrls.lookupTypeUpdate}`;
    return this.http.post<any>(link, body);
  }

  deleteLookupType(id: number) {
    const link = `${this.apiUrl}${ApiUrls.lookupTypeDelete}/${id}`;
    return this.http.post<any>(link, {});
  }

  getLookupItems(body: {
    pageIndex?: number;
    pageSize?: number;
    searchTerm?: string;
    lookupTypeId?: number;
  }) {
    const link = `${this.apiUrl}${ApiUrls.lookupItemGetList}`;
    return this.http.post<any>(link, body);
  }

  getLookupItemById(id: number) {
    const link = `${this.apiUrl}${ApiUrls.lookupItemGetById}/${id}`;
    return this.http.get<any>(link);
  }

  getLookupItemsByTypeId(lookupTypeId: number) {
    const link = `${this.apiUrl}${ApiUrls.lookupItemGetByLookupTypeId}/${lookupTypeId}`;
    return this.http.get<any>(link);
  }

  createLookupItem(body: {
    lookupTypeId?: number;
    LookupTypeId?: number;
    nameEn?: string;
    nameAr?: string;
    code?: string;
    NameEn?: string;
    NameAr?: string;
    Code?: string;
  }) {
    const link = `${this.apiUrl}${ApiUrls.lookupItemCreate}`;
    return this.http.post<any>(link, body);
  }

  updateLookupItem(body: {
    id?: number;
    Id?: number;
    lookupTypeId?: number;
    LookupTypeId?: number;
    nameEn?: string;
    nameAr?: string;
    code?: string;
    NameEn?: string;
    NameAr?: string;
    Code?: string;
  }) {
    const link = `${this.apiUrl}${ApiUrls.lookupItemUpdate}`;
    return this.http.post<any>(link, body);
  }

  deleteLookupItem(id: number) {
    const link = `${this.apiUrl}${ApiUrls.lookupItemDelete}/${id}`;
    return this.http.post<any>(link, {});
  }
}
